import React from 'react';

import { FormControl, FormHelperText, FormLabel, MenuItem, Select } from '@mui/material';

import languages from 'src/assets/language-codes/azure-tts';
import { VoicemailSettings } from 'src/hooks/core-api/useVoicemailSettings';

interface AgentLanguageVariantSelectProps {
  variants: AgentLanguageVariant[];
  onChange: (value: number) => void;
}

type AgentLanguageVariant = Pick<VoicemailSettings, 'agent_language_code' | 'alv_id'>;

const findLanguage = (languageCode: string) => {
  const match = languages.find(
    (language) => language.code.toLowerCase() === languageCode.toLowerCase()
  );

  if (!match) {
    return languageCode;
  }

  return match.language;
};

const AgentLanguageVariantSelect: React.FC<AgentLanguageVariantSelectProps> = ({
  variants,
  onChange,
}) => {
  const [value, setValue] = React.useState<number>(variants[0].alv_id ?? null);

  React.useEffect(() => {
    onChange(value);
  }, [value, onChange]);

  React.useEffect(() => {
    // Find if value in variants, if not set value to first variant (happens when changing location)
    const v = variants.map((variant) => variant.alv_id);

    if (!v.includes(value)) {
      setValue(variants[0].alv_id);
    }
  }, [variants, value]);

  return (
    <>
      <FormControl fullWidth>
        <FormLabel id="alv-label">Automated receptionist language</FormLabel>
        <Select
          labelId="alv-label"
          value={value}
          onChange={(event) => setValue(event.target.value as number)}
        >
          {variants.map((variant) => (
            <MenuItem key={variant.agent_language_code} value={variant.alv_id}>
              {findLanguage(variant.agent_language_code)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormHelperText>
        Select the automated receptionist language that you would like to configure voicemail
        notification emails for (each language can have its own settings)
      </FormHelperText>
    </>
  );
};

export default AgentLanguageVariantSelect;
